export {};
//# sourceMappingURL=emit-not-supported-error-function.js.map